import { mapGetters } from 'vuex';
import { ProjectContextGetters } from '../store/getters';
import { GeneralSettings } from '../enums/GeneralSettings';
import { UserDisplayFormat } from '../enums/userDisplayFormat';
import moment from 'moment';

export default {
	computed: {
		...mapGetters({
			selectedProjectSettings: [ProjectContextGetters.PROJECT_SETTINGS],
		}),
		dateFormat() {
			if (!this.selectedProjectSettings) return 'MM/DD/YYYY';
			return this.selectedProjectSettings.find(
				(x) => x.Name === GeneralSettings.DATE_FORMAT
			).Value;
		},
		dateTimeFormat() {
			if (!this.selectedProjectSettings) return 'MM/DD/YYYY';
			return this.selectedProjectSettings.find(
				(x) => x.Name === GeneralSettings.DATE_TIME_FORMAT
			).Value;
		},
	},
	methods: {
		getDateTimeFormat(date) {
			if (!date) return '';
			let format = this.getDateTimeFormatProjectSetting();
			let momentDate = moment(date).format(format);
			return momentDate;
		},
		getDateFormat(date) {
			if (!date) return '';
			let format = this.getDateFormatProjectSetting();
			let momentDate = moment.utc(date);
			let locale = momentDate.format(format);
			return locale;
		},

		getDateTimeFormatProjectSetting() {
			if (!this.selectedProjectSettings) return 'MM/DD/YYYY';
			let setting = this.selectedProjectSettings.find(
				(x) => x.Name === GeneralSettings.DATE_TIME_FORMAT
			);
			if (!setting) return 'MM/DD/YYYY';
			return setting.Value;
		},
		getDateFormatProjectSetting() {
			if (!this.selectedProjectSettings) return 'MM/DD/YYYY';
			let setting = this.selectedProjectSettings.find(
				(x) => x.Name === GeneralSettings.DATE_FORMAT
			);
			if (!setting) return 'MM/DD/YYYY';
			return setting.Value;
		},

		getGridsColumnWidth(entityType) {
			let setting = null;
			switch (entityType) {
				case 'Asset':
					setting = this.selectedProjectSettings.find(
						(x) => x.Name === GeneralSettings.GRID_ASSET_WIDTH
					);
					break;
				case 'Catalog':
					setting = this.selectedProjectSettings.find(
						(x) => x.Name === GeneralSettings.GRID_CATALOG_WIDTH
					);
					break;
				case 'Department':
					setting = this.selectedProjectSettings.find(
						(x) => x.Name === GeneralSettings.GRID_DEPARTMENT_WIDTH
					);
					break;
				case 'Name':
					setting = this.selectedProjectSettings.find(
						(x) => x.Name === GeneralSettings.GRID_NAMES_WIDTH
					);
					break;
				case 'Location':
					setting = this.selectedProjectSettings.find(
						(x) => x.Name === GeneralSettings.GRID_LOCATION_WIDTH
					);
					break;
				default:
					setting = this.selectedProjectSettings.find(
						(x) =>
							x.Name === GeneralSettings.GRID_CUSTOM_TABLE_WIDTH
					);
					break;
			}

			if (!setting) return '1';
			return setting.Value;
		},
		getUserFormat(firstName, lastName, email, username) {
			if (!this.selectedProjectSettings)
				return firstName + ' ' + lastName;
			let setting = this.selectedProjectSettings.find(
				(x) => x.Name === GeneralSettings.USER_DISPLAY_FORMAT
			);
			if (!setting) return firstName + ' ' + lastName;
			switch (parseInt(setting.Value)) {
				case UserDisplayFormat.Email:
					return email;
				case UserDisplayFormat.FirstName_LastName:
					return firstName + ' ' + lastName;
				case UserDisplayFormat.FirstName_LastName_Email:
					return firstName + ' ' + lastName + ' ' + email;
				case UserDisplayFormat.FirstName_LastName_Username:
					return firstName + ' ' + lastName + ' ' + username;
				case UserDisplayFormat.LastName_FirstName:
					return lastName + ' ' + firstName;
				case UserDisplayFormat.LastName_FirstName_Email:
					return lastName + ' ' + firstName + ' ' + email;
				case UserDisplayFormat.LastName_FirstName_Username:
					return lastName + ' ' + firstName + ' ' + username;
				case UserDisplayFormat.Username:
					return username;
				default:
					return firstName + ' ' + lastName;
			}
		},
	},
};
